import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// attach bearer token from storage as fallback
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Algo salió mal. Intenta de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatPrice(value, currency = "₡") {
  const n = Math.round(Number(value) || 0);
  const sign = n < 0 ? "-" : "";
  const grouped = String(Math.abs(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${currency}${sign}${grouped}`;
}

// Applies a percentage discount and returns rounded final price.
export function applyDiscount(price, discount = 0) {
  const d = Number(discount) || 0;
  if (d <= 0) return Math.round(Number(price) || 0);
  return Math.round((Number(price) || 0) * (1 - d / 100));
}
